<template>
   <div style="height:100%;
   -webkit-user-select:none;
   -moz-user-select:none;
   -ms-user-select:none;
   user-select:none; "
   >
    <menuNav :CurrentMenu="menuItem" :key="itemIndex" v-if="itemIndex == currentIndex" v-for="(menuItem, itemIndex) in allMenu"></menuNav>
  </div>
</template>
<script>
import menuNav from "./menuNav";

export default {
  components: { menuNav },
  data() {
    return {
      msg: "fwegwenhubgiwoelghijwe",
    };
  },
  computed: {
    currentIndex() {
      return this.$route.params.index;
    },
    allMenu() {
      let { currentIndex } = this;
      let _arr = this.$app.menus.filter((p) => p.children && p.children.length > 0);
      return _arr;
    },

  },
};
</script>
<style lang="scss" scoped>

</style>





